function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
function submitProject(projectId) {

    if (pageModel && pageModel()) {
        pageModel().save("Custom", "/Registrations/SubmitProject?ProjectId=" + projectId);
    } else {
        window.location = "/Registrations/SubmitProject?ProjectId=" + projectId;
    }

}
var oldValues;
var oldIndexes;
function convertValues(value) {
    var data = {};

    value = $.isArray(value) ? value : [value];
    /*
    if (oldValues != null) {
        for (var idx = 0; idx < oldValues.length; idx++) {
            data["old[" + idx + "]"] = oldValues[idx];
        }
    }
   
    oldValues = value;
     */
    for (var idx = 0; idx < value.length; idx++) {
        data["values[" + idx + "]"] = value[idx];
    }
    /*
    if (oldIndexes != null) {
        for (var idx = 0; idx < oldIndexes.length; idx++) {
            data["indexes[" + idx + "]"] = oldIndexes[idx];
        }
    }
    */
    


    return data;
}
///gets the positioning of an element on the window, set useAbsolutePositioning to true if you want to get absolute values
//ignoring container placement, good for absolute or fixed position elements
function getOffset(el, useAbsolutePositioning) {
    var rect = el.getBoundingClientRect();
    if (useAbsolutePositioning) {
        return {
            left: rect.left,
            top: rect.top
        };
    } else {
        return {
            left: rect.left + window.scrollX,
            top: rect.top + window.scrollY
        };
    }
    
}
function hideWithScroll(id) {
    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var header = document.getElementById(id);

    var checkScroll = function () {

        /*
        ** Find the direction of scroll
        ** 0 - initial, 1 - up, 2 - down
        */

        curScroll = w.scrollY || doc.scrollTop;
        if (curScroll > prevScroll) {
            //scrolled up
            direction = 2;
        }
        else if (curScroll < prevScroll) {
            //scrolled down
            direction = 1;
        }

        if (direction !== prevDirection) {
            toggleHeader(direction, curScroll);
        }

        prevScroll = curScroll;
    };

    var toggleHeader = function (direction, curScroll) {
        if (direction === 2 && curScroll > 52) {

            //replace 52 with the height of your header in px

            header.classList.add('hide');
            prevDirection = direction;
        }
        else if (direction === 1) {
            header.classList.remove('hide');
            prevDirection = direction;
        }
    };

    window.addEventListener('scroll', checkScroll);
}

///function for setting an internval to prevent some function from firing too often (such a scrolling)
function throttle(fn, wait) {
    var time = Date.now();
    return function () {
        if ((time + wait - Date.now()) < 0) {
            fn();
            time = Date.now();
        }
    }
}

/* Persist Grid Expand Helper Function
 * 
 * 
 * 
 * 
 * 
 * 
 * 
*/
function gridExpand(e) {
    var gridId = e.sender.element[0].id;
    var storedIds = JSON.parse(sessionStorage.getItem(gridId));
    var id = e.sender.dataItem(e.masterRow).id;
    var storedArrary = storedIds;
    if (storedIds == null) {
        storedArrary = [];
        storedArrary.push(id);
        sessionStorage.setItem(gridId, JSON.stringify(storedArrary));
    }
    else if (storedArrary.includes(id)) {
        return;
    }
    else {
        storedArrary.push(id);
        sessionStorage.setItem(gridId, JSON.stringify(storedArrary));
    }
}
function gridCollapse(e) {
    var gridId = e.sender.element[0].id;
    var id = e.sender.dataItem(e.masterRow).id;
    var storedIds = JSON.parse(sessionStorage.getItem(gridId));
    if (storedIds == null) {
        return;
    }
    else {
        var storedArrary = storedIds;
        var index = storedArrary.indexOf(id);
        storedArrary.splice(index, 1);
        sessionStorage.setItem(gridId, JSON.stringify(storedArrary));
    }
}
function expandStashedSite(gridName) {
    var grid = $("#"+gridName).data("kendoGrid");
    var data = grid.dataSource.data();
    var len = data.length;
    var savedIds = JSON.parse(sessionStorage.getItem(gridName));
    if (savedIds == null) {
        return;
    }
    for (var i = 0; i < len; i++) {
        var row = data[i];
        if (savedIds.includes(row.id)) {
            grid.expandRow("tr[data-uid='" + row.uid + "']");
        }
    }
}

function confirmAction(message) {
    if (!message) {
        message = "Are you sure?";
    }

    $.when(showWindow(message)).then(function (confirmed) {

        if (confirmed) {
            return true;
        } else {
            return false;
        }
    });
}

function onModalClose() {
    console.log("Global close modal");
}

function showSuccessOkWindow(message) {
    var dfd = new jQuery.Deferred();
    var result = false;

    window.confirmationDialog = $(
        '<div id="successDialog" class="actionConfirmedWindow" style="text-align: center; padding: 25px; cursor: default;">' +
        '<p><i class="fa fa-check-circle" aria-hidden="true" style="font-size: 3em;"></i></p>' +
        '<div class="popupMessage" style="margin-bottom: 20px;"></div >' +
        '<div style="text-align: center;">' +
        '<button type="button" class="btn btn_ok">Ok</button>' +
        "</div>" +
        "</div >")
        .kendoWindow({
            title: false,
            visible: false,
            minWidth: "300px",
            maxWidth: "450px",
            minHeight: "120px",
            modal: false,
            pinned: true,
            draggable: false,
            autoFocus: true,
            resizable: false,
            actions: [],
            close: function (e) {
                this.destroy();
                dfd.resolve(result);
            }
        }).data("kendoWindow");

    $(".popupMessage").html(message);
    confirmationDialog.center().open();

    $("#successDialog .btn_ok").click(function () {
        result = true;
        $("#successDialog").data("kendoWindow").close();
        //return dfd.promise(true);
    });

    return dfd.promise();
}

function showOkWindow(message) {

    var dfd = new jQuery.Deferred();
    var result = false;

    window.confirmationDialog = $(
            '<div id="confirmationDialog" class="actionErrorWindow" style="text-align: center; padding: 25px; cursor: default;">' +
            '<p><i class="fa fa-exclamation-circle" aria-hidden="true" style="font-size: 3em;"></i></p>' +
            '<div class="popupMessage" style="margin-bottom: 20px;"></div >' +
            '<div style="text-align: center;">' +
            '<button type="button" class="btn btn-default confirm_yes">Ok</button>' +
            "</div>" +
            "</div >")
        .kendoWindow({
            title: false,
            visible: false,
            minWidth: "300px",
            maxWidth: "450px",
            minHeight: "120px",
            modal: false,
            pinned: true,
            draggable: false,
            autoFocus: true,
            resizable: false,
            actions: [],
            close: function (e) {
                this.destroy();
                dfd.resolve(result);
            }
        }).data("kendoWindow");

    $(".popupMessage").html(message);
    confirmationDialog.center().open();

    $("#confirmationDialog .confirm_yes").val("OK");

    $("#confirmationDialog .confirm_yes").click(function () {
        result = true;
        $("#confirmationDialog").data("kendoWindow").close();
        //return dfd.promise(true);
    });

    return dfd.promise();
};
function diff(one, other, commonPartColor, additionColor, deletionColor,diffSentence) {
    var span = null;
    var diff = null;
    if (diffSentence == null || diffSentence == undefined) {
        diff = Diff.diffWords(one, other)
    }
    else {
        diff = Diff.diffSentences(one,other)
    }
    

    fragment = document.createDocumentFragment();
    if (commonPartColor == null || commonPartColor == undefined) {
        commonPartColor = "#888888";
    }
    if (additionColor == null || additionColor == undefined) {
        additionColor = "#284879";
    }

    if (deletionColor == null || deletionColor == undefined) {
        deletionColor = "#c34444";
    }
    diff.forEach(function(part) {
        // green for additions, red for deletions
        // grey for common parts
        
        if (part.removed) {
            span = document.createElement('s');
            span.style.color = deletionColor;
            span.appendChild(document
                .createTextNode(part.value));
            fragment.appendChild(span);
        }
        else {
            var color = part.added ? additionColor : commonPartColor;
            span = document.createElement('span');
            span.style.color = color;
            span.appendChild(document
                .createTextNode(part.value));
            fragment.appendChild(span);
        }

    });
    return fragment;
}

function showCustomWindow(message, buttonText, onCloseFunction) {

    var dfd = new jQuery.Deferred();
    var result = false;
    var defaultButtonText = "Ok";
    var defaultTypeClass = "actionErrorWindow";
    if (buttonText) {
        defaultButtonText = buttonText;
    }
    window.confirmationDialog = $(
        '<div id="confirmationDialog" class="actionErrorWindow" style="text-align: center; padding: 25px; cursor: default;">' +
        '<p><i class="fa fa-question-circle" aria-hidden="true" style="font-size: 3em;"></i></p>' +
        '<div class="popupMessage" style="margin-bottom: 20px;"></div >' +
        '<div style="text-align: center;">' +
        '<button type="button" class="btn btn-default confirm_yes">' + defaultButtonText + ' </button>' +
        "</div>" +
        "</div >")
        .kendoWindow({
            title: false,
            visible: false,
            minWidth: "300px",
            maxWidth: "450px",
            minHeight: "120px",
            modal: false,
            pinned: true,
            draggable: false,
            autoFocus: true,
            resizable: false,
            actions: [],
            close: function (e) {
                this.destroy();
                dfd.resolve(result);
            }
        }).data("kendoWindow");

    $(".popupMessage").html(message);
    confirmationDialog.center().open();

    $("#confirmationDialog .confirm_yes").val("OK");

    $("#confirmationDialog .confirm_yes").click(function () {
        result = true;
        $("#confirmationDialog").data("kendoWindow").close();
        if (onCloseFunction != undefined && onCloseFunction != null) {
            onCloseFunction();
        }
        
    });

    return dfd.promise();
};

function showWindow(message) {

    var dfd = new jQuery.Deferred();
    var result = false;

    window.confirmationDialog = $(
        '<div id="confirmationDialog" class="actionErrorWindow" style="text-align: center; padding: 25px; cursor: default;">' +
        '<p><i class="fa fa-question-circle" aria-hidden="true" style="font-size: 3em;"></i></p>' +
        '<div class="popupMessage" style="margin-bottom: 20px;"></div >' +
        '<div style="text-align: center;">' +
        '<button type="button" class="btn btn-default confirm_yes">Yes</button>' +
        '<button type="button" class="btn btn-default confirm_no">Cancel</button>' +
        "</div>" +
        "</div >")
        .kendoWindow({
            title: false,
            visible: false,
            minWidth: "300px",
            maxWidth: "450px",
            minHeight: "120px",
            modal: false,
            pinned: true,
            draggable: false,
            autoFocus: true,
            resizable: false,
            actions: [],
            close: function (e) {
                this.destroy();
                dfd.resolve(result);
            }
        }).data("kendoWindow");

    $(".popupMessage").html(message);
    confirmationDialog.center().open();

    $("#confirmationDialog .confirm_yes").val("OK");
    $("#confirmationDialog .confirm_no").val("Cancel");

    $("#confirmationDialog .confirm_no").click(function () {
        $("#confirmationDialog").data("kendoWindow").close();
        //return dfd.promise(false);
    });

    $("#confirmationDialog .confirm_yes").click(function () {
        result = true;
        $("#confirmationDialog").data("kendoWindow").close();
        //return dfd.promise(true);
    });

    return dfd.promise();
};


//returns true if first button was hit. false if second button is hit. 
function showWindowWithTwoOptions(message, firstButtonText, secondButtonText, includeCancel) {

    var dfd = new jQuery.Deferred();
    var result = false;

    window.confirmationDialog = $(
        '<div id="confirmationDialog" class="actionErrorWindow" style="text-align: center; padding: 25px; cursor: default;">' +
        '<p><i class="fa fa-question-circle" aria-hidden="true" style="font-size: 3em;"></i></p>' +
        '<div class="popupMessage" style="margin-bottom: 20px;"></div >' +
        '<div style="text-align: center;">' +
        '<button type="button" class="btn btn-default confirm_yes">' + firstButtonText + '</button>' +
        '<button type="button" class="btn btn-default confirm_no"> ' + secondButtonText + '</button>' +
        (includeCancel == true ? '<button type = "button" class= "btn btn-default cancel_action">Cancel</button>' : '') +
        "</div>" +
        "</div >")
        .kendoWindow({
            title: false,
            visible: false,
            minWidth: "300px",
            maxWidth: "575px",
            minHeight: "120px",
            modal: false,
            pinned: true,
            draggable: false,
            autoFocus: true,
            resizable: false,
            close: function (e) {
                this.destroy();
                dfd.resolve("close");
            }
        }).data("kendoWindow");

    $(".popupMessage").html(message);
    confirmationDialog.center().open();

    $("#confirmationDialog .confirm_yes").val("OK");
    $("#confirmationDialog .confirm_no").val("Cancel");

    $("#confirmationDialog .confirm_no").click(function () {
        result = false
        dfd.resolve("false")
        $("#confirmationDialog").data("kendoWindow").close();
        return dfd.promise();
    });


    $("#confirmationDialog .cancel_action").click(function () {
        result = false
        dfd.resolve("close")
        $("#confirmationDialog").data("kendoWindow").close();
        return dfd.promise();
    });

    $("#confirmationDialog .confirm_yes").click(function () {
        result = true;
        dfd.resolve("true")
        $("#confirmationDialog").data("kendoWindow").close();
        return dfd.promise();
    });

    return dfd.promise();
};
































var isSaving = false;

function beginSaving(savingText) {
    isSaving = true;
    if (savingText) {
        $(".loadingSpinnerText").html(savingText);
    } else {
        $(".loadingSpinnerText").html("Saving...");
    }
    $(".loading-bar").addClass("shown");

}

function nonAjaxPost(urlToPostTo, cancelUrl, data) {
    var form = $(document.createElement("form"));

    $(form).attr("action", urlToPostTo);
    $(form).attr("method", "POST");
    $(form).css("display", "none");

    var cancelUrlInput = $("<input>")
        .attr("type", "hidden")
        .attr("name", "cancelUrl")
        .val(cancelUrl);
    $(form).append($(cancelUrlInput));

    if (data) {
        var dataInput = $("<input>")
            .attr("type", "hidden")
            .attr("name", "stepData")
            .val(JSON.stringify(data));
        $(form).append($(dataInput));
    }

    form.appendTo(document.body);
    $(form).submit();
}

function endSaving() {
    isSaving = false;
    $(".loading-bar").removeClass("shown");
    $(".loadingSpinnerText").html("");
}

function showValidationErrorWindow(message) {
    var validationErrorDiv = document.createElement("div");

    validationErrorDiv.id = "validationErrorDialog";
    validationErrorDiv.style = "text-align: center; padding: 25px; cursor: default;";
    validationErrorDiv.classList.add("actionErrorWindow");
    if (message != null && message != undefined && message != "") {
        validationErrorDiv.innerHTML =
            "<p><i class='fa fa-exclamation-circle' aria-hidden='true' style='font-size: 3em;'></i></p>" +
            "<p class='actionText'>" + message +
            "<p>" +
            "<div class='actionList'>" +
            "<ul class='no-bullets' style='margin-bottom: 5px;'>" +
            "<li><a class='btn exit' href='#' onClick=\"$('#validationErrorDialog').data('kendoWindow').close()\"><i class='fa fa-times-circle' aria-hidden='true'></i> Ok</a></li>" +
            "</ul>" +
            "</div>";
    } else {
        validationErrorDiv.innerHTML =
            "<p><i class='fa fa-exclamation-circle' aria-hidden='true' style='font-size: 3em;'></i></p>" +
            "<p class='actionText'> Unable to save until all errors on the form are addressed and all required steps are completed." +
            "<p>" +
            "<div class='actionList'>" +
            "<ul class='no-bullets' style='margin-bottom: 5px;'>" +
            "<li><a class='btn exit' href='#' onClick=\"$('#validationErrorDialog').data('kendoWindow').close()\"><i class='fa fa-times-circle' aria-hidden='true'></i> Ok</a></li>" +
            "</ul>" +
            "</div>";
    }

    document.getElementById("pageBody").appendChild(validationErrorDiv);

    var validationErrorDialog = $("#validationErrorDialog").kendoWindow({
        title: false,
        visible: false,
        minWidth: "300px",
        maxWidth: "450px",
        minHeight: "120px",
        modal: false,
        pinned: true,
        draggable: false,
        autoFocus: true,
        resizable: false,
        close: function (e) {
            $("#validationErrorDialog").data("kendoWindow").destroy();
            if (message == null || message == undefined || message == ""){
            scrollToElement($(".has-error:first"), true, 300);
        };   
        },
        actions: []
    }).data("kendoWindow");

    validationErrorDialog.center().open();
}

function showLargeErrorWindow(text, stacktrace) {
    var errorDiv = document.createElement("div");

    if (text === undefined || text === "") {
        text = "An error occurred while saving.";
    }

    errorDiv.id = "errorDialog";
    errorDiv.style = "text-align: center; padding: 25px; cursor: default;";
    errorDiv.classList.add("actionErrorWindow");
    errorDiv.innerHTML = "<p><i class='fa fa-exclamation-circle' aria-hidden='true' style='font-size: 3em;'></i></p>" +
        "<p class='actionText'>" +
        text +
        "<p>" +
        "<div class='actionList'>" +
        "<ul class='no-bullets' style='margin-bottom: 5px;'>" +
        "<li><a class='btn' href='mailto:d%72%73-&#100;&#101;v&#64;%69%6cli&#110;ois%2ee&#100;&#117;'><i class='fa fa-envelope' aria-hidden='true'></i> Contact DRS</a></li>" +
        "<li><a class='btn exit' href='#' onClick=\"event.preventDefault(); event.stopPropagation();$('#errorDialog').data('kendoWindow').close()\"><i class='fa fa-times-circle' aria-hidden='true'></i> Close</a></li>" +
        "</ul>" +
        "</div>";

    document.getElementById("pageBody").appendChild(errorDiv);

    var errorDialog = $("#errorDialog").kendoWindow({
        title: false,
        visible: false,
        minWidth: "300px",
        maxWidth: "450px",
        minHeight: "120px",
        modal: false,
        pinned: true,
        draggable: false,
        autoFocus: true,
        resizable: false,
        close: function (e) {
            $("#errorDialog").data("kendoWindow").destroy();
        },
        actions: []
    }).data("kendoWindow");

    errorDialog.center().open();
}

function showErrorWindow(text) {
    var errorDiv = document.createElement("div");

    if (text === undefined || text === "") {
        text = "An error occurred while saving.";
    }

    errorDiv.id = "errorDialog";
    errorDiv.style = "text-align: center; padding: 25px; cursor: default;";
    errorDiv.classList.add("actionErrorWindow");
    errorDiv.innerHTML = "<p><i class='fa fa-exclamation-circle' aria-hidden='true' style='font-size: 3em;'></i></p>" +
        "<p class='actionText'>" +
        text +
        "<p>" +
        "<div class='actionList'>" +
        "<ul class='no-bullets' style='margin-bottom: 5px;'>" +
        "<li><a class='btn' href='mailto:d%72%73-&#100;&#101;v&#64;%69%6cli&#110;ois%2ee&#100;&#117;'><i class='fa fa-envelope' aria-hidden='true'></i> Contact DRS</a></li>" +
        "<li><a class='btn exit' href='#' onClick=\"event.preventDefault(); event.stopPropagation();$('#errorDialog').data('kendoWindow').close()\"><i class='fa fa-times-circle' aria-hidden='true'></i> Close</a></li>" +
        "</ul>" +
        "</div>";

    document.getElementById("pageBody").appendChild(errorDiv);

    var errorDialog = $("#errorDialog").kendoWindow({
        title: false,
        visible: false,
        minWidth: "300px",
        maxWidth: "450px",
        minHeight: "120px",
        modal: false,
        pinned: true,
        draggable: false,
        autoFocus: true,
        resizable: false,
        close: function (e) {
            $("#errorDialog").data("kendoWindow").destroy();
        },
        actions: []
    }).data("kendoWindow");

    errorDialog.center().open();
}

function showSuccessWindow(showActionButtons, onOpen, showViewListButton, viewListUrl, returnToUrl, returnToText, successText, viewListText, closeText) {
    var successDiv = document.createElement("div");

    successDiv.id = "successDialog";
    successDiv.style = "text-align: center; padding: 25px; cursor: default;";
    successDiv.classList.add("actionConfirmedWindow");
    if (closeText == null) {
        closeText = "Close"
    } 
    var innerHtml = "<p><i class='fa fa-check-circle' aria-hidden='true' style='font-size: 3em;'></i></p>" +
        "<p class='actionText'>Successfully saved.</p>";

    if (successText !== null && successText !== "" && successText !== undefined) {
        innerHtml = "<p><i class='fa fa-check-circle' aria-hidden='true' style='font-size: 3em;'></i></p>" +
        "<p class='actionText'>" + successText + "</p>"
    }
    console.log(onOpen);
    if (showActionButtons) {
        innerHtml = innerHtml +
            "<div class='actionList'>" +
            "<ul class='no-bullets' style='margin-bottom: 5px'>";

        if (returnToUrl) {
            if (returnToText === undefined || returnToText === "") {
                returnToText = "Return";
            }

            innerHtml = innerHtml + "<li><a class='btn' href='" +
                returnToUrl +
                "'><i class='fa fa-arrow-circle-left' aria-hidden='true'></i> " +
                returnToText +
                "</a></li>";
        }

        if (showViewListButton === undefined) {
            showViewListButton = true;
        }

        if (showViewListButton) {

            innerHtml = innerHtml +
                "<li><a class='btn' href='" + viewListUrl + "'><i class='fa fa-list' aria-hidden='true'></i> " + (viewListText !== null && viewListText !== "" && viewListText !== undefined ? viewListText : "View List") + "</a></li>";
        }

        innerHtml = innerHtml +
            "<li><a class='btn' href='/Account'><i class='fa fa-home' aria-hidden='true'></i> Go to My Dashboard</a></li>" +
            "<li><a class='btn exit' href='#' onClick=\"$('#successDialog').data('kendoWindow').close(); return false;\"><i class='fa fa-times-circle' aria-hidden='true'></i> " + closeText + "</a></li>" +
            "</ul>" +
            "</div>";
    }

    successDiv.innerHTML = innerHtml;
    document.getElementById("pageBody").appendChild(successDiv);

    var successDialog = $("#successDialog").kendoWindow({
        title: false,
        visible: false,
        minWidth: "300px",
        maxWidth: "450px",
        minHeight: "120px",
        modal: false,
        pinned: true,
        draggable: false,
        autoFocus: true,
        resizable: false,
        close: function (e) {
            $("#successDialog").data("kendoWindow").destroy();
        },
        actions: []
    }).data("kendoWindow");

    if (onOpen) {
        successDialog.setOptions({
            open: function () {
                onOpen();
            }
        });
    }

    successDialog.center().open();
}
/*Parameters:
 *  postUrl: The url that the ajax request posts to.
 *  pageModel: Gets cpnverted into Json model that is submitted in ajax post.
 *  direction: If manualUrl isn't populated, function checks direction to determine stepUrl.
 *  manualUrl: Used to populated stepUrl.
 *  previousStepUrl: Url of previous step. Used to populate stepUrl.
 *  nextStepUrl: Url of next step. Used to populate stepUrl.
 *  canSave: Determines if grid can be saved to.
 *  showViewListButton: Whether or not to show View List button in success window.
 *  viewListButtonUrl: Url of the View List button in the success window.
 *  returnToUrl: When populated, will add a button with returnToText as the text.
 *  returnToText: Text of button for returnToUrl.
 */
function wizardValidateAndSubmit(postUrl,
    pageModel,
    direction,
    manualUrl,
    previousStepUrl,
    nextStepUrl,
    cancelUrl,
    stepData,
    canSave,
    showViewListButton,
    viewListButtonUrl,
    noButtons,
    returnToUrl,
    returnToText,
    successText,
    viewListText,
    closeText) {
    console.log(noButtons);
    if (isSaving) {
        return;
    }

    if (canSave === undefined || canSave === '' || canSave === null) {
        canSave = true;
    }

    var stepUrl = null;

    if (manualUrl) {
        stepUrl = manualUrl;
    } else if (direction === "Next") {
        if (nextStepUrl !== null) {
            stepUrl = nextStepUrl;
        }
    } else if (direction === "Previous") {
        if (previousStepUrl !== null) {
            stepUrl = previousStepUrl;
        }
    }

    if (direction === "Manual") {
        nonAjaxPost(stepUrl, cancelUrl, stepData);
        return;
    }

    if (pageModel.isValid && !pageModel.isValid()) {
        var result = ko.validation.group(pageModel, { deep: true });
        console.log(result)
        result.showAllMessages(true);
        showValidationErrorWindow();
        return;
    }

    if (direction && direction !== "Custom" && pageModel.isDirty() === false) {
        nonAjaxPost(stepUrl, cancelUrl, stepData);
        return;
    }

    

    if (direction === null && !canSave) {
        showValidationErrorWindow();
        return;
    }

    if (!canSave) {
        // Go to the next step.
        pageModel.markClean();
        KoIsDirtyExtension.markEntirePageClean();
        nonAjaxPost(stepUrl, cancelUrl, stepData);
        return;
    }

    validateAndSubmit(postUrl, pageModel, showViewListButton, viewListButtonUrl, noButtons, returnToUrl, returnToText, stepUrl, cancelUrl, stepData, successText, viewListText,closeText);    
}

/*Parameters:
 *  postUrl: The url that the ajax request posts to.
 *  pageModel: Gets converted into Json model that is submitted in ajax post. Contains the data required for posting
 *  responseDataParentPath: The parent path outside the modal to pass the ajax post response data to
 */
function validateAndSubmitModal(postUrl,
    pageModel,
    onSuccess,
    canSave
    ) {
    if (isSaving) {
        return;
    }

    console.log(canSave)

    if (pageModel.isValid && !pageModel.isValid()) {
        var result = ko.validation.group(pageModel, { deep: true });
        result.showAllMessages(true);
        showValidationErrorWindow();
        return;
    }

    if (canSave !== null && !canSave && canSave !== undefined) {
        showValidationErrorWindow();
        return;
    }

    var jsonModel = ko.toJSON(pageModel);

    beginSaving("Saving...");

    $.ajax({
        url: postUrl,
        type: "POST",
        data: jsonModel ,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function (data) {
            endSaving();
            globalData = data;
            if (data && data.Exception) {
                showErrorWindow(data.Exception);
                return;
            } else {
                //no errors continue depending on parameters supplied
                if (pageModel.markClean !== undefined && pageModel.markClean !== null) {
                    pageModel.markClean();
                }

                KoIsDirtyExtension.markEntirePageClean();

                console.log(onSuccess);
                console.log(onSuccess(data));
                showSuccessWindow(false, onSuccess, false, null, null, null);
            }
            globalData = null;
        },
        error: function (jqXHR, textStatus, errorThrown) {
            endSaving();

            if (jqXHR.getResponseHeader("ErrorId")) {
                showErrorWindow("An error occurred while saving.  The error ID is: " +
                    jqXHR.getResponseHeader("ErrorId"));
            } else {
                showErrorWindow("An error occurred while saving.");
            }
        }
    });

}

/*Parameters:
 *  postUrl: The url that the ajax request posts to.
 *  pageModel: Gets converted into Json model that is submitted in ajax post. Contains the data required for posting
 *  onSuccess: The function to apply after saving, no window is shown unless configured in this function, on Success will have access to the data returned from the post
 */

function validateAndSubmitCustomAction(postUrl,
    pageModel,
    onSuccess,
    canSave
) {
    if (isSaving) {
        return;
    }

    console.log(canSave)
    
    if (pageModel.isValid && !pageModel.isValid()) {
        var result = ko.validation.group(pageModel, { deep: true });
        result.showAllMessages(true);
        showValidationErrorWindow();
        return;
    }

    if (canSave !== null && !canSave && canSave !== undefined) {
        showValidationErrorWindow();
        return;
    }

    var jsonModel = ko.toJSON(pageModel);

    beginSaving("Saving...");

    $.ajax({
        url: postUrl,
        type: "POST",
        data: jsonModel,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function (data) {
            endSaving();
            globalData = data;
            if (data && data.Exception) {
                showErrorWindow(data.Exception);
                return;
            } else {
                //no errors continue depending on parameters supplied
                if (pageModel.markClean !== undefined && pageModel.markClean !== null) {
                    pageModel.markClean();
                }

                KoIsDirtyExtension.markEntirePageClean();

                console.log(onSuccess);
                
                var debug = onSuccess(data);
                console.log(debug)
            }
            globalData = null;
        },
        error: function (jqXHR, textStatus, errorThrown) {
            endSaving();

            if (jqXHR.getResponseHeader("ErrorId")) {
                showErrorWindow("An error occurred while saving.  The error ID is: " +
                    jqXHR.getResponseHeader("ErrorId"));
            } else {
                showErrorWindow("An error occurred while saving.");
            }
        }
    });

}


function validateAndSubmit(
    postUrl,
    pageModel,
    showViewListButton,
    viewListButtonUrl,
    noButtons,
    returnToUrl,
    returnToText,
    stepUrl,
    cancelUrl,
    stepData,
    successText,
    viewListText,
    closeText,
    validateArrary,
    onSuccess
) {

    stepUrl = stepUrl === null ? false : stepUrl;
    showViewListButton = showViewListButton === null ? true : showViewListButton;
    noButtons = noButtons === null ? false : noButtons;
   
    if (pageModel.isValid && !pageModel.isValid()) {
        var result = ko.validation.group(pageModel, { deep: true });
        console.log(result())
        if (result().length != 0) {
            result.showAllMessages(true);
            showValidationErrorWindow();
            return
        }
        else {
            console.log(result())
        }
    }
    var result = ko.validation.group(pageModel, { deep: true });
    console.log(result().length)
    if (validateArrary == true && result().length != 0) {
        console.log(result())
        result.showAllMessages(true);
        showValidationErrorWindow();
        return;
    }
  
    var jsonModel = ko.toJSON(pageModel);

    beginSaving("Saving...");
    $.ajax({
        url: postUrl,
        type: "POST",
        data: jsonModel,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function (data) {
            endSaving();
            
            if (data && data.Exception) {
                showErrorWindow(data.Exception);
                return;
            } else {
                //no errors continue depending on parameters supplied
                if (pageModel.markClean != null && pageModel.markClean != undefined) {
                    pageModel.markClean();
                }

                KoIsDirtyExtension.markEntirePageClean();

                if (onSuccess != undefined && onSuccess != null && onSuccess != "" && onSuccess instanceof Function) {
                    onSuccess(data);
                }
                if (isValidUrl(data)) {
                    window.location.href = data;
                }
                console.log("marking clean and showing success window");
                if (stepUrl) {
                    showSuccessWindow(false, function () { setTimeout(function () { nonAjaxPost(stepUrl, cancelUrl, stepData); }, 1000); }, showViewListButton, viewListButtonUrl, returnToUrl, returnToText, successText, viewListText,closeText);
                } else if (noButtons) {
                    showSuccessWindow(false, function () { setTimeout(function () { $('#successDialog').data('kendoWindow').close(); }, 2500); }, showViewListButton, viewListButtonUrl, returnToUrl, returnToText, successText, viewListText,closeText);
                }
                else {
                    showSuccessWindow(true, null, showViewListButton, viewListButtonUrl, returnToUrl, returnToText, successText, viewListText, closeText);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            endSaving();
      


            if (jqXHR.getResponseHeader("ErrorId")) {
                showErrorWindow("An error occurred while saving.  The error ID is: " +
                    jqXHR.getResponseHeader("ErrorId"));
            } else {
                showErrorWindow("An error occurred while saving.");
            }
        }
    });
}
function isValidUrl(string) {
    try {
        new URL(string);
        return true;
    } catch (_) {
        return false;
    }
}
function validateModel(pageModel) {
    if (pageModel.isValid && !pageModel.isValid()) {
        var result = ko.validation.group(pageModel, { deep: true });
        result.showAllMessages(true);
        return false;
    } else {
        return true;
    }
}

function performAjaxPageAction(url, executingMessage, callback) {
    if (executingMessage === undefined) {
        executingMessage = "Saving...";
    }

    beginSaving(executingMessage);

    $.ajax({
        url: url,
        type: "GET",
        success: function (data) {
            endSaving();

            if (data && data.Exception) {
                showErrorWindow(data.Exception);
                return;
            } else {
                showSuccessWindow(false);
                if (callback) {
                    callback();
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            endSaving();

            if (jqXHR.getResponseHeader("ErrorId")) {
                showErrorWindow("An error occurred.  The error ID is: " +
                    jqXHR.getResponseHeader("ErrorId"));
            } else {
                showErrorWindow("An error occurred.");
            }
        }
    });
}

function getSelectedItems(selectedItems, availableItems, propertyComparer) {

    var selectedPropertyComparers = selectedItems.map(function (a) { return a[propertyComparer]; });

    return availableItems.filter(function (item) {
        var matchingValue = item[propertyComparer];
        var index = selectedPropertyComparers.indexOf(matchingValue);
        return index !== -1;
    });
}

$(".modal").on("hidden.bs.modal", function () {
    $(this).find('input[type="text"],input[type="email"],textarea,select').val("");
});

function stripTags(input){
    var div = document.createElement("div");
    div.innerHTML = input;
    return div.textContent || div.innerText || "";
}

function closeModal(selector) {
    $(selector).modal("hide");
}
function clearIFrame(selector) {
    $(selector).attr("src", "about:blank");
}

function formatDate(value, event) {
    console.log(value);
    var offsetMs = new Date().getTimezoneOffset() * 60 * 1000;
    var dateLocal = new Date(new Date(value).getTime() - offsetMs);
    var str = dateLocal.toISOString().slice(0, 19).replace(/-/g, "/").replace("T", " ");
    return str;
}

function scrollToElement($element, includeOffset, offsetValue) {
    var offsetRealValue = 0;
    if (includeOffset) {
        if (offsetValue) {
            offsetRealValue = offsetValue;
        } else {
            offsetRealValue = 210;
        }
    }
    $('html, body').animate({
        scrollTop: $element.offset().top - offsetRealValue
    }, 500);
}

function SetChangesIconsForGridSelector(gridSelector, status) {
    var grid = $(gridSelector).data("kendoGrid");
    if (grid !== null && grid !== undefined) {
        grid.items().each(function (index) {

            var dataItem = grid.dataItem(this);
            console.log(dataItem)
            if (dataItem.unapprovedChanges === true || dataItem.unapprovedAddition === true || dataItem.unapprovedDeletion === true) {
                this.className += " unapproved";
                if (dataItem.unapprovedAddition === true && dataItem.completedQuestions!=null) {
                    $(this).children("td").first().html('<span class="glyphicon glyphicon-plus-sign red"></span> ' + $(this).children("td").first().html());
                }
                else if (dataItem.unapprovedAddition === true) {
                    $(this).children("td").eq(1).html('<span class="glyphicon glyphicon-plus-sign red"></span> ' + $(this).children("td").eq(1).html());
                }

                if (dataItem.unapprovedDeletion === true && dataItem.completedQuestions != null) {
                    $(this).children("td").first().html('<span class="glyphicon glyphicon-remove red"></span> ' + $(this).children("td").first().html());
                }
                else if (dataItem.unapprovedDeletion === true) {
                    $(this).children("td").eq(1).html('<span class="glyphicon glyphicon-remove red"></span> ' + $(this).children("td").eq(1).html());
                }

                if (dataItem.unapprovedChanges === true && dataItem.completedQuestions != null) {
                    $(this).children("td").first().html('<span class="glyphicon glyphicon-refresh red"></span> ' + $(this).children("td").first().html());
                }
                else if (dataItem.unapprovedChanges === true ) {
                    $(this).children("td").eq(1).html('<span class="glyphicon glyphicon-refresh red"></span> ' + $(this).children("td").eq(1).html());
                }

                if (dataItem.materialReviewQuestions && status != undefined && status != "In Review") {
                    if (dataItem.materialReviewQuestions.length > 0) {
                        $(this).children("td").eq(1).html('<span class="glyphicon glyphicon-question-sign yellow"></span> ' + $(this).children("td").eq(1).html());
                    }
                }
                
            }

            if (dataItem.questionAnswers) {
                var hasReviewQuestions = false;
                for (var i = 0; i < dataItem.questionAnswers.length; i++) {
                    var thing = dataItem.questionAnswers[i];
                    if (thing.reviewQuestions.length > 0 && dataItem.materialReviewQuestions.length === 0) {
                        hasReviewQuestions = true;
                    }
                }

                if (hasReviewQuestions && status != undefined && status != "In Review") {
                    $(this).children("td").eq(1).html('<span class="glyphicon glyphicon-question-sign yellow"></span> ' + $(this).children("td").eq(1).html());
                }
            }
            
        })
    } else {
        console.log("cannot locate grid with selector " + gridSelector + " to set unapproved records.");
    } 
 
}

//Selector must be a table, the selector does not have to already have a kendo grid associated with it. 
//If it does not, it will clone the html and create the kendo grid locally inside the method to use.
function exportGridToExcelByHtmlSelector(kendoGridSelector, fileName) {
    var grid = undefined;

    //if selector hasn't been converted to a grid yet and it is a table element, convert it now
    if ($(kendoGridSelector).is("table")) {
        //sets that html table to be exported
        var selectorData = $(kendoGridSelector).clone().kendoGrid();
        grid = selectorData.data("kendoGrid");

    }

    if (grid != undefined) {
        exportGridToExcelByKendoGrid(grid, fileName);
    } else {
        console.log("Unable to find kendo grid data associated with selector " + kendoGridSelector + " in exportGridToExcelByHtmlSelector");
    }
}

function exportGridToExcelByKendoGrid(kendoGridObject, fileName) {

    if (kendoGridObject != null) {
        //binds to the excel export to remove <br/> and replace with new lines and sets
        //the column widths to not have tons of extra space
        bindCustomExportEvent(kendoGridObject);
       

        kendoGridObject.setOptions({
            excel: {
                fileName: (fileName != null && fileName != "" ? fileName : "DrsExcelData") + ".xlsx",
                allPages: true
            }
        });
        kendoGridObject.saveAsExcel();
    } else {
        console.log("Null parameter supplied for kendoGridObject in exportGridToExcelByKendoGrid");
    }
}

function bindCustomExportEvent(kendoGridObject, deferToPromise) {
    kendoGridObject.bind("excelExport", function (e) {
        var sheet = e.workbook.sheets[0];
        var columns = e.workbook.sheets[0].columns;
        var defaultColumnWidth = 64;
        var columnMaxCharCounts = [];

        //loop over the sheet rows
        for (var rowIndex = 0; rowIndex < sheet.rows.length; rowIndex++) {
            var row = sheet.rows[rowIndex];
            var heightMultiplier = 1;

            //loop over the rows columns (cells)
            for (var cellIndex = 0; cellIndex < row.cells.length; cellIndex++) {
                var cell = row.cells[cellIndex];

                var cellMaxCharLength;
                cell.value = cell.value.trim().toString();
                //if the cell contains <br/>, replace it with \n so it displays correctly in Excel
                if (cell.value && cell.value.toString().indexOf("<br>") >= 0) {

                    var stringsSplitByLineBreaks = cell.value.split("<br>");
                    //add to the height multiplier for each instance of line breaks found in the cell
                    heightMultiplier += cell.value.trim().indexOf("<br>") !== -1 ? stringsSplitByLineBreaks.length - 1 : 0;
                    cell.value = cell.value.trim().replaceAll("<br>", "\n");
                    cell.value = cell.value.trim();
                    cell.wrap = true;

                    //get the longest character count from all the split strings for determining which split value has the highest character count
                    cellMaxCharLength = stringsSplitByLineBreaks.reduce(function (a, b) {
                        return a.length > b.length ? a.length : b.length;
                    }
                    );
                } else {
                    //no <br/> in column, just get the length of the string
                    cellMaxCharLength = cell.value.trim().length;
                }

                //setup the array that tracks the max character count per column by column index
                var currentMaxCharCount = columnMaxCharCounts.find(function (x) { return x.ColumnIndex == cellIndex });
                if (currentMaxCharCount == null || currentMaxCharCount == undefined) {
                    columnMaxCharCounts.push({ ColumnIndex: cellIndex, CharCount: cellMaxCharLength });
                } else {
                    currentMaxCharCount.CharCount = cellMaxCharLength > currentMaxCharCount.CharCount ?
                        cellMaxCharLength : currentMaxCharCount.CharCount;
                }
            }

            if (heightMultiplier != 1) {
                row.height = heightMultiplier * 20; //the default excel row height
            }
        }

        //go over every column and set the new widths based on the max character count found in each column index
        for (var i = 0; i < columns.length; i++) {
            var column = columns[i];
            var maxCharLength = columnMaxCharCounts.find(function (x) { return x.ColumnIndex == i });
            delete column.width;
            column.autoWidth = false;
            column.width = maxCharLength.CharCount * 8;
            console.log("Post-Change: Column width for column " + i + ": " + column.width);
        }

        if (deferToPromise != null && deferToPromise != undefined) {
            e.preventDefault();
            deferToPromise.resolve(e.workbook);
        }
    });
}